import { ChevronLeft, ChevronRight } from 'lucide-react';

// Cuántos hay, cuáles estás viendo y cómo llegar al resto.
//
// Lo importante de esta pieza no son los botones: es la frase «de 347».
// Una lista que se recorta sola sin decirlo es peor que una lista lenta,
// porque el usuario cree que ya lo vio todo y decide con eso.
//
// total = null significa «el servidor no lo dijo». No se traduce a cero ni
// se inventa: se cae al modo antiguo (página N, siguiente si vino llena).
export default function Paginador({
  pagina, porPagina, total, mostrados, cargando, onPagina,
}) {
  const desconocido = total === null || total === undefined;
  const paginas = desconocido ? null : Math.max(1, Math.ceil(total / porPagina));

  // Nada que paginar y nada que aclarar: fuera. Una barra de paginación
  // bajo una tabla de seis renglones es ruido.
  if (!desconocido && total <= porPagina && pagina === 0) {
    if (total === 0) return null;
    return (
      <p className="text-sm text-gray-500 tabular-nums" aria-live="polite">
        {total} {total === 1 ? 'registro' : 'registros'}
      </p>
    );
  }

  const desde = pagina * porPagina + 1;
  const hasta = pagina * porPagina + (mostrados ?? 0);
  const hayAnterior = pagina > 0;
  // Sin total, la única pista es que la página vino llena.
  const haySiguiente = desconocido
    ? (mostrados ?? 0) >= porPagina
    : hasta < total;

  return (
    <nav
      aria-label="Paginación"
      className="flex items-center justify-between gap-3 flex-wrap"
    >
      <p className="text-sm text-gray-600 tabular-nums" aria-live="polite">
        {desconocido ? (
          <>Página {pagina + 1}</>
        ) : mostrados > 0 ? (
          <>
            Mostrando <strong className="font-semibold text-gray-900">{desde}–{hasta}</strong>
            {' de '}
            <strong className="font-semibold text-gray-900">{total}</strong>
          </>
        ) : (
          <>Sin resultados en esta página de {total}</>
        )}
      </p>

      <div className="flex items-center gap-2">
        <Boton
          onClick={() => onPagina(pagina - 1)}
          disabled={!hayAnterior || cargando}
          etiqueta="Página anterior"
        >
          <ChevronLeft className="h-4 w-4" /> Anteriores
        </Boton>
        {paginas !== null && (
          <span className="text-sm text-gray-500 tabular-nums px-1">
            {pagina + 1} / {paginas}
          </span>
        )}
        <Boton
          onClick={() => onPagina(pagina + 1)}
          disabled={!haySiguiente || cargando}
          etiqueta="Página siguiente"
        >
          Siguientes <ChevronRight className="h-4 w-4" />
        </Boton>
      </div>
    </nav>
  );
}

function Boton({ children, etiqueta, ...props }) {
  return (
    <button
      type="button"
      aria-label={etiqueta}
      {...props}
      className="inline-flex items-center gap-1 text-sm font-semibold px-3 py-1.5 rounded-lg
                 border border-gray-300 bg-white text-gray-700 hover:bg-gray-50
                 disabled:opacity-40 disabled:cursor-not-allowed
                 focus:outline-none focus:ring-2 focus:ring-[var(--color-marca)] focus:ring-offset-1"
    >
      {children}
    </button>
  );
}
